<template>
  <div class="shop-container">
    <transition name="fade-top" v-if="source=='h5'">
      <div class="ph-notice">
        <div class="wrapper">
        <img src="https://res.ponhu.cn/new/logo200_200.jpg" alt="" class="logo">
        <div class='tips-box'>
          <span style="font-weight: bold;">胖虎奢侈品</span>
          <span class="gift-info">领取1188元新人券，买满立减</span>
        </div>
        </div>
        <div class="download-btn">
          <a href="javascript:;" @click="opneapp">立即打开</a>
          <!-- <span @click="download">立即打开</span> -->
        </div>
      </div>
    </transition>
    <div class="goods-swiper">
      <div class="goods-swiper-back" v-if="source=='h5'">
        <van-icon name="arrow-left" size="20px" color="#fff" @click="$router.back(-1)" />
      </div>
      <van-swipe class="goods-swipe" :autoplay="3000" :show-indicators="false" @change="onChange">
        <van-swipe-item v-for="(item, index) in goods.pictureCollection" :key="index" @click="preview(index)">
          <img :src="item + '?imageView2/1/w/750/h/750'">
        </van-swipe-item>
      </van-swipe>
      <div class="dots" v-if="goods.pictureCollection && goods.pictureCollection.length > 1" :style="{bottom: goods.activityLabel == 1 || goods.activityLabel == 2 ? '50px' : '10px'}"><p v-for="index in goods.pictureCollection.length" :key="index" :style="{background: swiperIndex == index ? '#ffd133' : '#FFF'}"></p></div>
      <!-- <div class="goods-swiper-like" v-if="source=='h5'">
        <van-icon name="like" size="20px" @click="like" color="#ffd133" />
      </div> -->
      <div class="goods-swiper-active" v-if="goods.activityLabel == 1">
        <!-- <div class="active-title">
          <van-icon name="underway-o" size="20px" />
          <span style="margin-left:5px">限时特卖尽情GO！</span>
        </div> -->
        <img src="@/assets/img/xs_bg.png" class="img_bg" />
        <div class="countdown">
          <van-count-down :time="time" :format="tiemFormat">
            <template v-slot="timeData">
              <span class="item">{{ timeData.hours>=10?timeData.hours:'0'+timeData.hours }}</span> :
              <span class="item">{{ timeData.minutes>=10?timeData.minutes:'0'+timeData.minutes }}</span> :
              <span class="item">{{ timeData.seconds>=10?timeData.seconds:'0'+timeData.seconds }}</span>
            </template>
          </van-count-down>
        </div>
      </div>
      <div class="goods-swiper-active" v-if="goods.activityLabel == 2">
        <img src="@/assets/img/tm_bg.png" class="img_bg" />
      </div>
    </div>
    <!-- 商品信息 -->
    <div class="goods-info-wrapper" :class="goods.offerDescription?'':'mb24'">
      <div class="goods-info">
      <div class="price-wrapper" v-if="goods.commodityStatus!=3">
        <div class="goods-price">{{ goodsPrice }}</div>
        <div class="goods-phprice" v-if="goods.activityLabel && goods.originalPrice > goodsPrice">{{ goods.originalPrice }}</div>
        <div class="goods-mrprice" v-if="goods.marketPrice>0" >市场价 {{ goods.marketPrice }}</div>
        <div style="margin-left: 10px;" v-if="goods.discount!=''">{{ goods.discount }}</div>
      </div>
      <div class="price-wrapper" v-if="goods.commodityStatus==3">
        <div class="goods-sq">已售罄</div>
      </div>
      <div class="goods-chengse">
        <span class="cs">{{ goods.commodityColor }}</span>
        <van-icon name="question-o" size="20px" @click="checkCS" />
      </div>
      </div>
      <div class="goods-name">
        <span class="transfer-flag ziying" v-if="goods.merchantLabel == 1">胖虎自营</span>
        <span class="transfer-flag youxuan" v-if="goods.merchantLabel == 2">优选商家</span>
        {{ goods.brandName + goods.categoryName}}
      </div>
    </div>
    <div class="cop_tig mb24" v-if="goods.offerDescription">
      <span class="flag-youhui">优惠</span>
      {{goods.offerDescription}}
    </div>
    <!-- 店铺信息 -->
    <div class="goods-store">
      <div class="goods-store-wrapper">
        <div class="goods-store-info">
          <img :src="goods.shopTrademark" alt="" class="store-logo">
          <span class="store-name">{{goods.shopName}}</span>
        </div>
        <!-- <van-button plain hairline round type='ph-default' v-if="goods.merchantLabel == 1"  size="small" @click="showStore = true">到店体验</van-button> -->
      </div>
      <div class="goods-store-content ph-triangle_top">{{goods.description}}</div>
    </div>
    <!-- 服务栏 -->
    <div class="goods-serve mb24">
      <div class="goods-serve-title c999">服务</div>
      <div class="goods-serve-content">
        <span>泰康保真</span>
        <span class="dot">·</span>
        <span>专业鉴定</span>
        <span class="dot">·</span>
        <span>售后无忧</span>
      </div>
      <van-icon size="20px" name='weapp-nav' @click="checkServe" />
    </div>
    <!-- 商品参数 -->
    <div class="goods-params mb24">
      <div class="goods-item-title">商品参数</div>
      <div class="goods-params-content">
        <div class="params-table">
          <div class="item" v-for="(item,index) in canshu" :key='index'>
            <span>{{item.pname}}</span>
            <span>{{item.pval}}
              <!-- <em>{{item.pval}}</em> -->
              <van-icon name="question-o" size="15px" @click="checkCS" color='#999' v-if="item.pname == '成色'"/>
            </span>
          </div>
        </div>
      </div>
      <div class="goods-qrcode" @click="checkQRcode">
        <img src="@/assets/picture/ma.jpeg" alt="">
        <span class="c999">查看商品二维码 </span>
      </div>
    </div>
    <!-- 交易流程 -->
    <div class="goods-tradeProcess mb24">
      <div class="goods-item-title ph-line">交易流程</div>
      <div class="goods-tradeProcess-content">
        <img src="@/assets/img/shop-process1.png" alt=""  srcset=""  v-if="goods.merchantLabel == 0"> 
        <img src="@/assets/img/shop-process2.png" alt="" srcset="" v-if="goods.merchantLabel != 0" >
      </div>
    </div>
    <!-- 商品详情 -->
    <div class="goods-detail mb24">
      <div class="goods-item-title">商品详情</div>
      <div class="goods-detail-content">
        <div class='goods-detail-item' style="margin-bottom: 10px;" v-for="thumb in goods.pictureCollection" :key="thumb">
          <img :src="thumb + '?imageView2/1/w/760/h/760'">
        </div>
      </div>
    </div>
    <!-- 推荐列表 -->
    <div class="goods-recommend-list" id="anchor">
      <div class="goods-item-title fw">
        <span class="fz36">推荐相似</span>
        <span class="fz20">RECOMMEND</span>
      </div>
       <div class="goods-recommend-content">
        <good-grid :list='recomendList'></good-grid>
        <van-divider :style="{ color: '#ccc', borderColor: '#ccc', padding: '0 90px' , height: '105px' , marginTop:'-30px'}">已经到底了</van-divider>
       </div>
    </div>
    <!-- 操作栏 -->
    <van-goods-action :safe-area-inset-bottom='safeArea'>
      <van-goods-action-icon @click="onCheckStore" v-if="source=='h5'">
        <img style="width : .5rem;margin-left: 28%;" src="@/assets/picture/home.jpeg" alt="">
        <span style="padding-top: .15rem;">首页</span>
      </van-goods-action-icon>
      <van-goods-action-icon @click="custService = true">
        <img style="width : .5rem;margin-left: 28%;" src="@/assets/picture/kefu.jpeg" alt="">
        <span style="padding-top: .09rem;">客服</span>
      </van-goods-action-icon>
      <!-- <van-goods-action-button type="info" @click="wishList" v-if="!goods.occupy&&goods.commodityStatus!=3&&source=='h5'">
        加入心愿单
      </van-goods-action-button> -->
      <van-goods-action-button type="danger" @click="createOrder" v-if="!goods.occupy&&goods.commodityStatus!=3">
        立即购买
      </van-goods-action-button>
      <van-goods-action-button type="info" v-if="goods.occupy&&goods.commodityStatus!=3">
        付款中 <van-count-down :time="occupyTime" :format="tiemFormat" style="color:#fff;" />
      </van-goods-action-button>
      <van-goods-action-button type="info" @click="ysq" v-if="goods.commodityStatus==3">
        查看相似商品
      </van-goods-action-button>
    </van-goods-action>

    <!-- 成色说明 -->
    <action-sheet ref="actionSheetCS">
      <div class="goods-cs-wrapper">
        <div class="goods-cs-title fw ph-line">成色说明</div>
        <div class="goods-cs-content" v-if="goods.primaryClassification!=1">
          <div class="goods-cs-item">
            <span class="label">99新(未使用): </span>
            <span class="describe">全新未使用，附件齐全(盒子、防尘、卡等)</span>
          </div>
          <div class="goods-cs-item">
            <span class="label">98新: </span>
            <span class="describe">
                商品未使用，附件缺失，或因陈列或存放产生的极细微的污渍、划痕等情况。
            </span>
          </div>
          <div class="goods-cs-item">
            <span class="label">95新: </span>
            <span class="describe">
              整体成色较新，金属类配件微氧化，轻微划痕、边角磨损但不明显，整体品相完整。
            </span>
          </div>
          <div class="goods-cs-item">
            <span class="label">9新: </span>
            <span class="describe">
              有日常使用痕迹，局部有少数划痕、污渍、五金轻微变色等情况，品相良好。
            </span>
          </div>
          <div class="goods-cs-item">
            <span class="label">85新: </span>
            <span class="describe">
              有明显使用痕迹，金属类氧化变色，边角磨损凸显，局部有明显划痕、污渍等，品相普通。
            </span>
          </div>
          <div class="goods-cs-item">
            <span class="label">8新: </span>
            <span class="describe">
              有长期使用痕迹，整体陈旧不洁，局部有较为严重的划痕、污渍、磨损等情况，品相较差但不影响正常使用。
            </span>
          </div>
        </div>
        <div class="goods-cs-content" v-if="goods.primaryClassification==1">
          <div class="goods-cs-item">
            <span class="label">99新(未使用)</span>
            <span class="describe">全新或者买回来以后没有用过，保存状态很好，配件齐全。</span>
          </div>
          <div class="goods-cs-item">
            <span class="label">98新</span>
            <span class="describe">
                手表因运输或存放以及陈列后产生轻微的痕迹，手表未使用但有长时间放置痕迹，整体状态很好，金属无磨损，皮带无破损，后盖无开启痕迹。手表功能状态良好，皮带有轻微折痕，手表边角有轻微划痕。
            </span>
          </div>
          <div class="goods-cs-item">
            <span class="label">95新</span>
            <span class="describe">
              有轻微的佩戴痕迹，边角有轻微的磨损，有划痕，皮带有佩戴过的弯折痕迹，表盘无水印，后盖未多次开启，只因正常保养开启后盖，皮表带轻微汗渍。或手表未使用过但有明显保存痕迹，但达不到98新级别。
            </span>
          </div>
          <div class="goods-cs-item">
            <span class="label">9新</span>
            <span class="describe">
              有使用痕迹，手表有磨损，有明显划痕，手表外壳以及表带有小磕伤，表盘无明显水印，后盖因保养开启，没有维修痕迹。皮带有深度折印（不好修复），皮带内汗渍较重，手表功能无损坏。
            </span>
          </div>
          <div class="goods-cs-item">
            <span class="label">85新</span>
            <span class="describe">
              有明显的使用痕迹，手表外观有明显磨损，深度划痕，外观有磕伤，表盘有轻微进水痕迹，表针表盘轻微氧化，机芯无大修痕迹，手表各功能无损坏，贵金属表壳有轻微氧化变色。皮带有破损，轻微裂皮。
            </span>
          </div>
          <div class="goods-cs-item">
            <span class="label">8新</span>
            <span class="describe">
              整体明显使用痕迹，手表整体使用磨损痕迹深而且明显，有少数较深磕伤。表针表盘并未整体氧化，有进水后水印，机芯大修但并未换件，手表基本功能未受损。贵金属表壳有明显变色痕迹，皮带开裂严重，折印开裂。
            </span>
          </div>
        </div>
        <van-button class="tk_btn" type="info" size="large" @click="cancelActionSheet">确认</van-button>
      </div>
    </action-sheet>
    <!-- 服务说明 -->
    <action-sheet ref="actionSheetServe">
      <div class="goods-cs-wrapper">
        <div class="goods-cs-title fw ph-line">服务说明</div>
        <div class="goods-cs-content">
          <div class="goods-serve-item">
            <span class="label fw">
              <van-icon name="search" size="15px" color="#DA3232"/>泰康保真</span>
            <span class="describe">泰康保险】在胖虎购买并发货到用户手中的商品，经第三方或中检国检鉴定不是正品的，胖虎会给您办理退款并由泰康保险提供商品价格20%的赔款数。（需提供胖虎的防伪标签、鉴定证书）</span>
          </div>
          <div class="goods-serve-item">
            <span class="label fw">
               <van-icon name="search" size="15px" color="#DA3232"/>专业鉴定</span>
            <span class="describe">
               胖虎拥有强大的资深鉴定师团队，中国二手奢侈品行业协会专业鉴定委员会授权鉴定中心，中检奢侈品鉴定中心战略合作协议，《时尚芭莎》官方鉴定和售后服务合作伙伴。
            </span>
          </div>
          <div class="goods-serve-item">
            <span class="label fw">
               <van-icon name="search" size="15px" color="#DA3232"/>售后无忧</span>
            <span class="describe">
              因奢侈品属于贵重物品，故除商品真伪问题以外，不予退货。如需换货，请在收到货的48小时内联系客服。非质量问题，换货产生的邮费，由买家承担。如果对商品真伪存疑，请不要拆卸胖虎奢侈品正品保证防伪标签，可以联系客服进行第三方检验。
            </span>
          </div>
        </div>
        <van-button class="tk_btn" type="info" size="large" @click="serveActionSheet">确认</van-button>
      </div>
    </action-sheet>
    <van-action-sheet v-model="custService">
      <service-sheet @close="custService=false"></service-sheet>
    </van-action-sheet>
    <van-popup v-model="showStore" style="background:transparent">
      <div class="store-popup">
        <div class="store-close" @click="showStore=false">
          <img src="@/assets/img/close.png" />
        </div>
        <div class="store-con">
          <div class="title">预约到店</div>
          <div class="content">添加胖虎微信客服: {{serviceWechat.sale}} 预约到店体验，享受更多专属服务</div>
          <div class="clip-btn" @click="onSelect(serviceWechat.sale,'.clip-btn')">复制微信</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Download from '@/components/common/Download'
import ActionSheet from '@/components/business/ActionSheet'
import GoodGrid from '@/components/business/GoodGrid'
import { CountDown, ImagePreview } from 'vant'
import { getActivityGoodsDetails, getRecommendList, getGoodsParameter, putWishGoods } from '@/api/good'
import { getWxUrl } from '@/api/order'
import ServiceSheet from '@/components/business/ServiceSheet'
import ClipboardJS from 'clipboard'
import { openApp, BrowserInfo, getAppUserToken, getWechatNumber } from '@/utils'
import wxapi from '@/utils/wxApi'

export default {
  components: {
    Download,
    ActionSheet,
    GoodGrid,
    ServiceSheet,
    [CountDown.name]: CountDown
    // PhHeader
  },
  data () {
    return {
      islike: true,
      showStore: false,
      actionSheetShow: true,
      custService: false,
      previewInstance: '',
      safeArea: true,
      gid: '',
      brandId: '',
      brandName: '',
      categoryId: '',
      time: 0,
      occupyTime: 0,
      swiperIndex: 1,
      tiemFormat: 'HH:mm:ss',
      goods: {},
      canshu: [],
      recomendList: [],
      goodsPrice: '¥0',
      isOut: false,
      source: '',
      serviceWechat: {}
    }
  },
  computed: {
    token () {
      return this.$store.getters.token
    }
  },
  watch: {
	  '$route' (to, from) {
		  if (to.params.gid != from.params.gid) {
			  this.gid = to.params.gid
			  this.getGoodsData()
		  }
	  }
  },
  mounted() {
    this.source = this.$route.query.source || 'h5'
    if (this.source === 'appr') { // 设置平台渠道为鉴定神器
      this.$store.dispatch('setPlatformChannel', '10')
      let appr_token = getAppUserToken() || ''
      this.$store.dispatch('LoginByUser', appr_token)
    } else {
      this.$store.dispatch('setPlatformChannel', '9')
    }
  },
  created () {
    this.gid = this.$route.params.gid
    this.getGoodsData()
    getWechatNumber().then(res => {
      this.serviceWechat = res
    })
  },
  
  methods: {
    onChange(index) {
      this.swiperIndex = index + 1;
    },
    // 商品信息
    getGoodsData () {
      this.$toast.loading({
        mask: true,
        message: '加载中...'
      })
      getActivityGoodsDetails({ commodityId: this.gid, userToken: this.token }).then(res => {
        this.goods = res
        this.time = res.remainingTime * 1000
        // this.tiemFormat = 'HH:mm:ss'
        // if (res.remainingOccupationTime >= 3600) {
        //   this.tiemFormat = 'HH:mm:ss'
        // } else {
        //   this.tiemFormat = 'mm:ss'
        // }
        this.occupyTime = res.remainingOccupationTime * 1000
        let price = res.activityLabel !== 0 ? res.discountPrice : res.originalPrice
        this.goodsPrice = '¥' + price
        getGoodsParameter({ commodityId: this.gid }).then(resq => {
          this.canshu = resq
        }).catch(error => {
          console.log(error)
        })
        getRecommendList({ brandId: res.brandId, categoryId: res.primaryClassification, commodityId: this.gid }).then(resp => {
          this.recomendList = resp
        }).catch(error => {
          console.log(error)
        })
        wxapi.wxRegister(this.wxRegCallback)
        this.$toast.clear()
      }).catch(error => {
        window.location.href = process.env.VUE_APP_ROOT_URL + 'index.html#/';
        console.log(error)
      })
    },
    // 商品参数
    getGoodsParameterData () {
      getGoodsParameter({ commodityId: this.gid }).then(res => {
        this.canshu = res
      }).catch(error => {
        console.log(error)
      })
    },
    // 查看成色说明
    checkCS () {
      this.$refs.actionSheetCS.change()
    },
    cancelActionSheet () {
      this.$refs.actionSheetCS.change()
    },

    // 查看服务说明
    checkServe () {
      this.$refs.actionSheetServe.change()
    },
    serveActionSheet () {
      this.$refs.actionSheetServe.change()
    },
    //复制微信
    onSelect (item, node) {
      let that = this
      var clipboard = new ClipboardJS(node, {
        text: function (trigger) {
          return item
        }
      })
      clipboard.on('success', function (e) {
        that.$toast('微信号已经复制到粘贴板！')
        e.clearSelection()
      })

      clipboard.on('error', function (e) {
        that.$toast('该设备不支持自动复制')
      })
      this.custService = false
      this.showStore = false
    },
    // 查看商品二维码
    checkQRcode () {
      this.$router.push({ name: 'shopGoodsQrcode' })
    },

    // 店铺
    onCheckStore () {
      this.$router.push({ name:'home' })
    },
    // 创建订单
    createOrder () {
      if (this.token) {
        // 清理结算缓存
        this.$store.dispatch('BalanceOut')
        let url = '/pay/balance/' + this.gid + '?tap=1'
        if (BrowserInfo().isWeixin) {
          getWxUrl({ url: url, label: 1 }).then(res => {
            location.href = res
          })
        } else {
          this.$router.push({ path: '/pay/balance/' + this.gid })
        }
        // getWxUrl({ url: url, label: 1 }).then(res => {
        //   location.href = res
        // })
      } else {
        if (this.source === 'appr') {
          var pl = BrowserInfo()
          if (pl.isIOS) {
            this.$IOS.IosTransferLogin()
          } else {
            this.$Android.AndroidTransferLogin()
          }
        } else {
          this.$router.push({ path: '/login?return_url=' + window.location.href })
        }
      }
    },
    // 打开app
    opneapp () {
      var pl = BrowserInfo()
      if (pl.isWeixin) { 
        if (pl.isIOS) {
          window.location.href = "https://apps.apple.com/app/apple-store/id1021204443?pt=117887550&ct=VIP&mt=8"
        } else {
          var txt = 'type=20&id='+this.gid
          var clipboard = new ClipboardJS(txt, {
            text: function (trigger) {
              return item
            }
          })
          clipboard.on('success', function (e) {
            e.clearSelection()
          })
          clipboard.on('error', function (e) {
            console.log('该设备不支持自动复制')
          })
          window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.gian.punkhoo&android_schema=ponhu://m.ponhu.cn/goodDetail?pid='+this.gid
        }
      } else if (pl.isIOS) {
        window.location.href = 'ponhu://type=20&id='+this.gid
      } else {
        window.location.href = 'ponhu://m.ponhu.cn/goodDetail?pid='+this.gid
      }

    },
    //  加入心愿单
    wishList () {
      if (this.token) {
        putWishGoods({ goodsId: this.gid, userToken: this.token }).then(res => {
          this.$toast('添加成功')
        }).catch(err => {
          this.$toast(err)
        })
      } else {
        this.$router.push({ path: '/login?return_url=' + window.location.href })
      }
    },
    ysq () {
      let ele = document.getElementById('anchor')
      ele.scrollIntoView(
        { behavior: 'smooth', block: 'start', inline: 'center' } || true
      )
    },

    /**
     * @method preview 商品预览
     * @Parma {Number} index 起始位置
     * @Parma {Array} 预览图片
     */
    preview (index) {
      this.previewInstance = ImagePreview({
        images: this.goods.pictureCollection,
        lazyLoad: true,
        startPosition: index
      })
    },

    // 微信注册
    wxRegCallback () {
      // 微信分享
      this.wxShareTimeline()
      this.wxShareAppMessage()
    },
    wxShareTimeline () {
      let _this = this
      let option = {
        title: _this.goods.brandName + _this.goods.categoryName,
        link: process.env.VUE_APP_ROOT_URL + 'index.html#/goods/' + _this.gid,
        imgUrl: _this.goods.pictureCollection[0] + '?imageView2/1/w/300/h/300',
        success: () => {
          _this.$toast('分享成功')
        },
        error: () => {
          _this.$toast('已取消分享')
        }
      }
      // 将配置注入通用方法
      wxapi.ShareTimeline(option)
    },
    wxShareAppMessage () {
      let _this = this
      let option = {
        title: _this.goods.brandName + _this.goods.categoryName,
        desc: _this.goods.description,
        link: process.env.VUE_APP_ROOT_URL + 'index.html#/goods/' + _this.gid,
        imgUrl: _this.goods.pictureCollection[0] + '?imageView2/1/w/300/h/300',
        success: () => {
          _this.$toast('分享成功')
        },
        error: () => {
          _this.$toast('已取消分享')
        }
      }
      // 将配置注入通用方法
      wxapi.ShareAppMessage(option)
    }
  }
}
</script>

<style lang="less">

.goods-swiper-active {
  position: absolute !important;
  bottom: 0;
}
.goods-cs-wrapper {
  height: 770px !important;
}
.dots {
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: center;
  
  p {
    width: 14px;
    height: 14px;
    margin: 5px;
    border-radius: 50%;
  }
}
.transfer-flag{
  width:100px;
  height:30px;
  text-align: center;
  font-size:20px;
  font-weight:400;
  padding: 2px 4px;
  line-height:30px;
  border-radius:2px;
  margin-right: 10px;
}
// 优选商家
.youxuan {
  background:rgba(40,40,40,1);
  color: rgba(255, 209, 51, 1);
}
// 胖虎自营
.ziying {
  background: #FF9015;
  color: rgba(40,40,40,1);
}
.flag-youhui {
  background-color: #DA3232;
  color: #fff;
  margin-right: 30px;
  height:30px;
  font-size:20px;
  font-weight:400;
  padding: 2px 20px;
}
.cop_tig {
  background-color: #FFF1BF;
  padding: 16px 24px;
  font-size: 24px;
  color: #DA3232;
}
  .goods {
    padding-bottom: 100px;
    &-swiper{
      position: relative;
      height: 750px;
      &-back{
        position: absolute;
        width: 60px;
        height: 60px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba(0,0,0,.4);
        left: 24px;
        top: 24px;
        z-index: 1;
      }
      &-like{
        position: absolute;
        width: 60px;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        background-color: rgba(0,0,0,.4);
        right: 24px;
        top: 24px;
      }
      &-active{
        display: flex;
        position: relative;
        justify-content: space-between;
        // padding: 0 24px;
        // height:98px;
        // background:linear-gradient(217deg,rgba(255,209,51,1) 0%,rgba(255,51,91,1) 100%);
        .active-title{
          color: #fff;
          font-size: 32px;
          display: flex;
          align-items: center;
        }
        .img_bg {
          width: 100%;
          display:block;
          height: 100px;
        }
        .countdown{
          font-weight: bold;
          // display: flex;
          // justify-content: flex-end;
          // align-items: center;
          -webkit-box-flex: 1;
          -webkit-flex: 1;
          -moz-box-flex: 1;
          -ms-flex: 1;
          flex: 1;
          position: absolute;
          right: 24px;
          top: 36px;
          .item{
            display: inline-block;
            width:40px;
            height:40px;
            text-align: center;
            color: #fff;
            font-size: 24px;
            background:rgba(218,50,50,1);
            border-radius:4px;
          }
        }
      }
    }
    &-swipe {
      img {
        width: auto;
        display: block;
        height: 750px;
        margin: 0 auto;
      }
    }
    &-info-wrapper{
      background: #fff;
      padding-bottom: 20px;
      .goods-info {
        padding: 20px 24px 10px;
        font-size: 24px;
        display: flex;
        align-items: center;
        .price-wrapper{
          display: flex;
          align-items: center;
          flex: 1;
        }
        .goods{
          &-price {
            color: #f44;
            font-size: 42px;
            font-weight: bold;
            margin-right: 20px;
          }
          &-phprice {
            color:#999;
            margin-right: 10px;
            align-items: flex-end;
          }
          &-mrprice {
            color:#999;
            align-items: flex-end;
          }
          &-chengse{
            display: flex;
            align-items: center;
            justify-content: flex-end;
            .cs{margin-right: 10px;color: #282828;font-weight: bold;}
          }
          &-sq {
            font-size:36px;
            font-weight:600;
            color:#282828;
            line-height:50px;
          }
        }
      }
    }
    &-name {
      padding: 0 24px;
      font-size: 32px;
      text-align: left;
      font-weight: bold;
    }

    &-cs-wrapper{
      font-size: 24px;
      text-align: left;
      color: #1B1B1B;
      height: 900px;
      .goods-cs-title{
        padding: 20px 24px;
        font-size: 32px;
        margin-bottom: 20px;
        position: fixed;
        width: 100%;
        background-color: #fff;
      }
      .goods-cs-content {
        padding: 100px 0;
      }
      .goods-cs-item{
        padding: 0 24px;
        display: flex;
        margin-bottom: 20px;
        .label{
          display: inline-block;
          flex-basis: 25%;
          font-size: 26px;
          font-weight: bold;
          // color: #1B1B1B;
        }
        .describe{
          font-size: 24px;
          color: #4C4C4C;
          line-height: 1.5;
          flex: 1;
        }
      }
      .goods-serve-item{
        padding: 0 24px;
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        .label{
          display: inline-block;
          flex-basis: 25%;
          font-size: 26px;
          margin-bottom: 10px;
          display: flex;
          align-items: center;
          i{margin-right: 10px;}
        }
        .describe{
          font-size: 24px;
          color: #4C4C4C;
          line-height: 1.5;
          flex: 1;
        }
      }
    }
    &-item-title{
      padding: 20px 0;
      font-size: 28px;
      // margin-bottom: 20px;
    }
    &-store{
      background: #fff;
      font-size: 24px;
      padding: 24px;
      &-wrapper{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 14px;
        .goods-store-info{
          display: flex;
          align-items: center;
          .store-logo{
            width:76px;
            height:76px;
            border-radius: 50%;
            margin-right: 20px;
          }
        }
        .van-button{
          height: 30px;
          line-height: 30px;
        }
      }
      &-content{
        background: #F7F7F7;
        padding: 24px;
        text-align: left;
        position: relative;
      }
    }
    &-serve{
      background: #fff;
      font-size: 24px;
      padding: 0 24px;
      display: flex;
      align-items: center;
      &-content{
        flex: 1;
        padding: 24px;
        text-align: left;
        display: flex;
        align-items: center;
        justify-content: space-around;
        .dot{
          height: 17px;
          line-height: 17px;
          color: #FFD133;
          font-size: 5em;
        }
      }
    }
    &-params{
      background: #fff;
      font-size: 24px;
      padding: 0 24px;
      text-align: left;
      &-content{
        .params-table{
          display: table;
          width: 100%;
          // border: 1px solid red;
          border-collapse:collapse;
          .item{
            display: table-row;
            span{
              width: 100px;
              padding: 15px 24px;
              border: 1px solid #E5E5E5;
              display: table-cell;
              vertical-align: middle;
              .van-icon{vertical-align:text-top;}
            }
            span:last-child{
              user-select: all;
              -webkit-user-select: all;
            }
          }

        }
      }
      .goods-qrcode{
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 24px 0;
        img{width: 35px;}
        span{margin-left: 10px}
      }
    }
    &-tradeProcess{
      background: #fff;
      font-size: 24px;
      padding: 0 24px;
      text-align: left;
      &-content{
        padding: 24px 0;
        img{
          display: block;
          width: 100%;
        }
      }
    }
    &-detail{
      background: #fff;
      font-size: 24px;
      padding: 0 24px;
      // display: flex;
      // align-items: center;
      text-align: left;
      &-content{
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      &-item{
        img{
          display: block;
          width: 100%;
        }
      }
    }
    &-recommend-list{
      margin: 0 auto;
      .goods-item-title{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
      }
      .goods-recommend-content{
        padding: 0 24px;
      }
    }
    // &-express {
    //   color: #999;
    //   font-size: 12px;
    //   padding: 5px 15px;
    // }

    // &-cell-group {
    //   margin: 15px 0;
    //   .van-cell__value {
    //     color: #999;
    //   }
    // }

    // &-tag {
    //   margin-left: 5px;
    // }
  }
  .store-popup{
    width:580px;
    height:420px;
    box-sizing: border-box;
    position: relative;
    background: transparent;
    .store-close {
      width: 56px;
      height: 80px;
      position: absolute;
      right: 0;
      top: 0;
    }
    .store-con {
      position: relative;
      top: 80px;
      padding: 40px 80px;
      width:580px;
      height:340px;
      box-sizing: border-box;
      background-color: #fff;
      border-radius:12px;
      .title{
        text-align: center;
        font-weight: bold;
        font-size: 32px;
        margin-bottom: 20px;
      }
      .content{
        word-break: break-all;
        font-size: 28px;
        margin-bottom: 20px;
      }
      .clip-btn{
        margin: 0 auto;
        text-align: center;
        width:160px;
        color: #FDD133;
        height:56px;
        line-height: 56px;
        font-size: 24px;
        background:rgba(40,40,40,1);
        border-radius:4px;
      }
    }
  }
  .goods-phprice,.goods-mrprice{
    text-decoration:line-through;
  }
.van-count-down {
    color: #fff;
    font-size: 14px;
    line-height: 20px;
    display: inherit;
    margin-left: 6px;
}
.action-btn {
  width: 100%;
  height: 100%;
  border: 0;
  background-color: transparent;
}
.tk_btn {
    position: fixed;
    bottom: 0;
}

.fade-top-enter, .fade-top-leave-to {
  transform: translate3d(0, -100%, 0)
}
.fade-top-leave, .fade-top-enter-to {
  transform: translate3d(0, 0, 0)
}
.fade-top-enter-active, .fade-top-leave-active {
  transition: all .2s
}
.ph-notice{
  background: #fff;
  margin: 0 auto;
  padding: 16px 24px;
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
  .wrapper{
    flex:1;
    display: flex;
    align-items: center;
    font-size: 28px;
    color: #282828;
    .logo{
      width: 87px;
      height: 87px;
    }
    .tips-box{
      display: flex;flex-direction: column;margin-left: .3rem;
      text-align:left;
      .gift-info{font-size:24px;color:#999;padding-top: 0.1rem;}
    }
  }
  .download-btn {
    width:160px;
    height:56px;
    background:#FF9015;
    border-radius:28px;
    a{
      display: block;
      width:160px;
      height:56px;
      line-height: 56px;
      color: #000;
      font-size: 24px;
      text-align: center;
    }
  }
}
</style>
